import { Box, Text } from "@chakra-ui/react";
import { forwardRef } from "react";
import { useHeader } from "../../hooks/useHeader";

const ContentBox = forwardRef(
  /**
   * @typedef {object} Props
   * @property {string} [title]
   * @property {boolean} [isHighlighted]
   * @property {import("react").ReactNode} children
   *
   * @param {Props} props
   */
  function ContentBox({ title, isHighlighted = false, children }, ref) {
    const { headerHeight } = useHeader();

    return (
      <Box
        ref={ref}
        scrollMarginTop={headerHeight + 16}
        borderWidth="1px"
        borderRadius="0.375rem"
        outline={isHighlighted ? "2px solid" : undefined}
        outlineColor={isHighlighted ? "brandPrimary.500" : undefined}
        p="1.25rem">
        {title && (
          <Text
            fontSize="1.125rem"
            fontWeight={400}
            lineHeight="1.75rem"
            mb="1.5rem">
            {title}
          </Text>
        )}

        {children}
      </Box>
    );
  },
);

export default ContentBox;
